document.addEventListener('DOMContentLoaded', () => {
  const formItemQuantity = $('#item-quantity-form');
  const formShipping = $('#shipping-form');
  const shippingSelector = $('#checkout-shipping-address');

  $('.checkout-shipping-address__change-cep').click(function () {
    const changeCep = $('.checkout-shipping-address__choose-method');
    const changeAddress = $('.checkout-shipping-address__consult-cep');

    changeCep.click(function () {
      $(this).addClass('hidden');

      changeAddress.fadeIn('slow', function () {
        changeAddress.removeClass('hidden');
      });
    });
  });

  shippingSelector.change(function () {
    formShipping.submit();
  });

  $('input.quantity-change').change(function (event) {
    if (!event.target.checkValidity()) {
      const input = event.target;
      const max = parseInt(event.target.max, 10);
      const quantityMessage = document.querySelector('.quantity-message');

      quantityMessage.innerHTML = `O estoque possui apenas ${max} ${max === 1 ? 'item' : 'itens'}`;
      input.value = max;

      setTimeout(() => {
        quantityMessage.innerHTML = '';
        formItemQuantity.submit();
      }, 5000);
      return;
    }

    formItemQuantity.submit();
  });

  $('.checkout-form__quantity').each(function () {
    const spinner = $(this);
    const input = spinner.find('input[type="number"]');
    const btnUp = spinner.find('.quantity-up');
    const btnDown = spinner.find('.quantity-down');
    const min = input.attr('min');
    const max = input.attr('max');

    btnUp.click(function () {
      const oldValue = parseFloat(input.val());
      let newVal;

      if (oldValue >= max) {
        newVal = oldValue;
      } else {
        newVal = oldValue + 1;
      }
      spinner.find('input').val(newVal);
      spinner.find('input').trigger('change');
    });

    btnDown.click(function () {
      const oldValue = parseFloat(input.val());
      let newVal;

      if (oldValue <= min) {
        newVal = oldValue;
      } else {
        newVal = oldValue - 1;
      }
      spinner.find('input').val(newVal);
      spinner.find('input').trigger('change');
    });
  });
});



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/checkout/checkout.js